import { toTeams } from 'utils/serializers'

const toOption = option => {
  if (option) {
    return option.value
  }
  return null
}

export const convertFromProfile = userDetails => {
  return {
    firstName: userDetails.firstName || '',
    lastName: userDetails.lastName || '',
    title: userDetails.title || '',
    teams: toTeams(userDetails.teams),
    phone: userDetails.phone || '',
    email: userDetails.email || '',
    fax: userDetails.fax || '',
    cellPhone: userDetails.cellPhone || '',
    address: userDetails.address || '',
    address2: userDetails.address2 || '',
    street2: userDetails.street2 || '',
    city: userDetails.city || '',
    state: userDetails.state || '',
    zipcode: userDetails.zipcode || '',
    image: userDetails.image || '',
    emailIntegration: userDetails.emailIntegration,
    organization: userDetails.organization,
    timezone: userDetails.timezone
      ? { value: userDetails.timezone, label: userDetails.timezone }
      : '',
    department: userDetails.department
      ? {
          value: userDetails.department.id,
          label: userDetails.department.name
        }
      : null
  }
}

export const convertToProfile = userDetails => {
  return {
    ...userDetails,
    teams: userDetails.teams.map(t => t.value),
    departmentId: toOption(userDetails.department),
    timezone: toOption(userDetails.timezone)
  }
}

export const toUserFormData = fileInfo => {
  const { file, crop } = fileInfo
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
    formData.append('cropX', crop.x)
    formData.append('cropY', crop.y)
    formData.append('cropWidth', crop.width)
    formData.append('cropHeight', crop.height)
  }
  return formData
}

export const toDepartments = departments =>
  departments.map(d => ({
    value: d.id,
    label: d.name
  }))
